import React from "react";
import httpRequest from "helper-xhr";
import { Wheel } from './wheel.jsx';

class WheelsResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  };

  render() {

    var me = this;

    var ret = null;

    if (this.props.lines && this.props.lines[0]) {

      var lines = this.props.lines;

      var HM_COLS = this.props.HM_COLS;

      //////////////////////////////// TODO


      var banners = null;

      if (window.WheelBanners != null) {
        banners = WheelBanners.banners.map((banner, ii) => {
          return (
            <img src={banner} className="w-100" />
          );
        });
      }

      var grid = lines.reduce((rows, key, index) => (index % HM_COLS == 0 ? rows.push([key])
        : rows[rows.length - 1].push(key)) && rows, []);

      grid = grid.map((row, ii) => {
        var boxes = row.map((v, i, a) => {
          var banner = null;

          //key = { "grid" + ii + "-" + i }
          //DetailsUrl is unfornutately the closest thing to a unique key I have available here
          return (
            <Wheel
              key={v.DetailsUrl}
              wheelDetails={v}
              car={this.props.car}
              year={this.props.year}
              filters={this.props.filters}
              localWheelSelectDiameter={this.props.localWheelSelectDiameter}
              howManyColumns={HM_COLS}
            />
          );
        });

        //////////////////////////////// TODO

        if (window.WheelBanners != null) {
          if ((ii != 0) && ((ii % window.WheelBanners.step) == 0)) {
            boxes.splice(0, 0,
              <div className="col-12" key={"banner" + ii} style={{ marginBottom: "20px" }}>
                {banners[(ii / window.WheelBanners.step) % banners.length]}
              </div>
            );
          }
        }

        return (
          <div key={"grid" + ii}
            className="row wheels-list">
            {boxes}
          </div>
        );
      });

      ret = (
        <div>
          {grid}
        </div>
      );
    }

    return ret;
  }
}

export { WheelsResults };